import axios from "axios";
import { MessageBox, Indicator } from "mint-ui";
import global_ from "../global.config";
import Cookies from "js-cookie";
import Qs from 'qs'
import wx from "weixin-js-sdk";

// 是否获取过 是否在小程序中
let isGetIsInMiniProgram = false;
// 是否在小程序中小程序状态
let isInMiniProgram = false;
/**
 * 在request里面也做了判断，需要改的时候，请同步更改
 */
function checkIsHuafa() {
  if (location.host.indexOf("localhost") > -1) {
    if (global_.API_DOMAIN.indexOf("huafacrm") > -1 || global_.API_DOMAIN.indexOf("huafamarkting") > -1) {
      return true;
    } else {
      return false;
    }
  } else {
    if (location.host.indexOf(".huafamarkting.") > -1 || location.host.indexOf(".huafacrm.") > -1) {
      return true
    } else {
      return false
    }
  }
}

let wj = {
  browser: {
    info: navigator.appVersion,
    versions: (function () {
      let u = navigator.userAgent;
      return {
        trident: u.indexOf("Trident") > -1,
        presto: u.indexOf("Presto") > -1,
        webKit: u.indexOf("AppleWebKit") > -1,
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1,
        iPad: u.indexOf("iPad") > -1,
        webApp: u.indexOf("Safari") == -1,
        wx: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      };
    })()
  }
}

function getIsInMiniProgram(currentIsInMiniProgram) {
  return new Promise(function (resolve, reject) {
    if (currentIsInMiniProgram == undefined) {
      if (global_.isLoc && global_.isMp) {
        resolve(true);//模拟小程序里面分享
      }
      if (wj.browser.versions.wx) {
        wx.miniProgram.getEnv(function (res) {
          resolve(res.miniprogram);
        });
      } else {
        resolve(false);
      }
    } else {
      resolve(currentIsInMiniProgram);
    }
  })
}


const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。"
};

let cancel;
// promiseArr = {};
const CancelToken = axios.CancelToken;
//请求拦截器
axios.interceptors.request.use(
  config => {
    //发起请求时，取消掉当前正在进行的相同请求
    // if (promiseArr[config.url]) {
    //   promiseArr[config.url]("操作取消");
    //   promiseArr[config.url] = cancel;
    // } else {
    //   promiseArr[config.url] = cancel;
    // }

    // 聊天请求定制
    if (config.url.indexOf(global_.API_CHAT) > -1) {
      config.headers.Authorization = "Bearer " + Cookies.get('yqrsmake_chattoken');
    }
    //直播请求定制 或者 /m/ 请求
    if (config.url.indexOf(global_.API_URL_LIVES) > -1 || config.url.indexOf('/m/') > -1) {
      // config.headers.ContentType = "application/x-www-form-urlencoded";
      config.headers.openId = Cookies.get('openid');
      config.headers.passport = Cookies.get('passport');
    }

    if (config.params && (config.params.action || config.params.requestParam)) {
      let obj = {
        openid: Cookies.get("openid") || "",
        passport: Cookies.get("passport") || "",
        vericode: Cookies.get("vericode") || "",
        url: location.href,
        action: config.params.action,
        requestParam: config.params.requestParam || {}
      };

      if(config.params.hasIndicator) {
        obj.hasIndicator = true
      }

      if (location.href.indexOf("record/record") > -1 && obj.action.indexOf("/aliyun/AliyunAction/sts") > -1) {
        if (location.host.indexOf("localhost") > -1 || location.host.indexOf("qmyx") > -1) {
          obj.openid = "oj3y9wGThdLqhn0bZWOj7DeO2Tww";
          obj.passport = "b4de197ab7b03e9d014116821e90d54f";
        } else {
          obj.openid = "ooSW7wCba7oABRNDGptiL95zK6Ho";
          obj.passport = "eceb50439b45126f2782d627809c1095";
        }
      }
      if (checkIsHuafa() && (isInMiniProgram || location.href.indexOf("ismp=1") > -1)) {
        // 解决微信request域名数量限制
        if (location.host.indexOf("localhost") > -1) {
          // 是本地用api子域名
          obj.appsubdomain = global_.SUBDOMAIN;
        } else {
          // 不是本地用站点子域名
          obj.appsubdomain = location.hostname.substring(0, location.hostname.indexOf("."));
        }
        if (config.url.indexOf("huafacrm.com") > -1) {
          config.url = config.url.replace(obj.appsubdomain, "qmyx");
        } else if (config.url.indexOf("huafamarkting.com") > -1) {
          config.url = config.url.replace(obj.appsubdomain, "rushi");
        }
      }
      let params = {
        j: JSON.stringify(obj),
        t: Math.ceil(Math.random() * 1000)
      };
      config.params = params;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    if (response.request.responseURL.indexOf("hasIndicator") > -1) {
      Indicator.close()
    }

    // 聊天响应定制
    if (response.request.responseURL.indexOf("/m/user/account/bind") > -1) {

    } else if (response.request.responseURL.indexOf("yqaitech.com") > -1) {

    } else if (response.request.responseURL.indexOf(global_.API_CHAT) > -1) {

    } else if (response.request.responseURL.indexOf("wxmp.ruthus.com") > -1) {
      // 请求在线售楼中心小程序接口

    } else if (response.request.responseURL.indexOf("/huafa/weixin/") > -1) {
      // 请求华发接口

    } else if (response.request.responseURL.indexOf("/live/publicplatform/") > -1) {
      // 请求直播接口

    } else if (response.request.responseURL.indexOf("hdk.rstthd.com/henduobao/api/") > -1) {
      // 请求很多宝的接口
      return response.data;
    } else if (response.request.responseURL.indexOf("openApi/getAreaByIp") > -1) {
      // 请求获取城市接口
    } else if (response.request.responseURL.indexOf("falsedata") > -1 ||
      response.request.responseURL.indexOf("h5count.do") > -1) {
    } else if (response.request.responseURL.indexOf(".rstthd.") > -1) {
      //请求很多客的接口
      if (response.request.responseURL.indexOf("open/findUserByUnionid") > -1) {
        // 这个接口如果没有找到用户的话返回 {code:1000}
      } else if (response.data.code !== 200) {
        MessageBox("提示", response.data.errmsg || response.data.msg || response.data.code);
        return Promise.reject(response.data);
      }
    } else if (response.request.responseURL.indexOf("/saleslead/") > -1) {
      // 请求光哥销售线索接口

    } else if (response.request.responseURL.indexOf("houseConfirmCustomerVisitedAndSaveCrmUser") > -1) {
      return response.data;
    } else if (response.request.responseURL.indexOf("/openApi/firstRegister") > -1 && response.data.code == -4585) {
      console.log('disanfang')
      return JSON.parse(response.data)
    } else if (response.data.code !== 0 && response.data.code !== 997) {
      MessageBox("提示", response.data.errmsg || response.data.msg || response.data.code);
      return Promise.reject(response.data);
    }
    global_.paramKeys.forEach(name => {
      if (name in response.data) {
        Cookies.set(name, response.data[name], { expires: 30 });
      }
    });
    return response.data;
  },
  err => {
    // if (err && err.response) {
    //   err.message =
    //     codeMessage[err.response.status] || `连接错误${err.response.status}`;
    // } else {
    //   err.message = "连接到服务器失败";
    // }
    // MessageBox("提示", err.message);
    // return Promise.resolve(err.response);
    return Promise.reject(err.response);
  }
);

// axios.defaults.baseURL = global_.API_URL;
// //设置默认请求头
// axios.defaults.headers = {
//   "X-Requested-With": "XMLHttpRequest"
// };

axios.defaults.headers = {
  "Content-Type": "text/plain"
};
axios.defaults.headers = {
  "Content-Type": "application/json"
};

axios.defaults.timeout = 1000 * 60 * 5;

export default {
  get(url, param, option) {
    if (option && option.mask) {
      // Indicator.open();
    }
    return new Promise((resolve, reject) => {
      if (isGetIsInMiniProgram == false) {
        getIsInMiniProgram().then(tmpBool => {
          isGetIsInMiniProgram = true;
          isInMiniProgram = tmpBool;
          axios({
            method: "get",
            url,
            params: param,
            cancelToken: new CancelToken(c => {
              cancel = c;
            })
          })
            .then(res => {
              if (option && option.mask) {
                // Indicator.close();
              }
              resolve(res);
            })
            .catch(function (error) {
              // Indicator.close();
            });
        })
      } else {
        axios({
          method: "get",
          url,
          params: param,
          cancelToken: new CancelToken(c => {
            cancel = c;
          })
        })
          .then(res => {
            if (option && option.mask) {
              // Indicator.close();
            }
            resolve(res);
          })
          .catch(function (error) {
            // Indicator.close();
          });
      }
    });
  },
  get2(url, param, option) {
    if (option && option.mask) {
      // Indicator.open();
    }
    return new Promise((resolve, reject) => {
      if (isGetIsInMiniProgram == false) {
        getIsInMiniProgram().then(tmpBool => {
          isGetIsInMiniProgram = true;
          isInMiniProgram = tmpBool;
          axios({
            method: "get",
            url,
            params: param,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            cancelToken: new CancelToken(c => {
              cancel = c;
            })
          })
            .then(res => {
              if (option && option.mask) {
                // Indicator.close();
              }
              resolve(res);
            })
            .catch(function (error) {
              // Indicator.close();
            });
        })
      } else {
        axios({
          method: "get",
          url,
          params: param,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          cancelToken: new CancelToken(c => {
            cancel = c;
          })
        })
          .then(res => {
            if (option && option.mask) {
              // Indicator.close();
            }
            resolve(res);
          })
          .catch(function (error) {
            // Indicator.close();
          });
      }
    });
  },
  post(url, param, option) {
    if (option && option.mask) {
      // Indicator.open();
    }
    return new Promise((resolve, reject) => {
      if (isGetIsInMiniProgram == false) {
        getIsInMiniProgram().then(tmpBool => {
          isGetIsInMiniProgram = true;
          isInMiniProgram = tmpBool;
          axios({
            method: "post",
            url,
            data: param,
            cancelToken: new CancelToken(c => {
              cancel = c;
            })
          })
            .then(res => {
              if (option && option.mask) {
                // Indicator.close();
              }
              resolve(res);
            })
            .catch(function (error) {
              // Indicator.close();
            });
        })
      } else {
        axios({
          method: "post",
          url,
          data: param,
          cancelToken: new CancelToken(c => {
            cancel = c;
          })
        })
          .then(res => {
            if (option && option.mask) {
              // Indicator.close();
            }
            resolve(res);
          })
          .catch(function (error) {
            // Indicator.close();
          });
      }
    });
  },
  post2(url, param, option) {
    if (option && option.mask) {
      // Indicator.open();
    }
    return new Promise((resolve, reject) => {
      if (isGetIsInMiniProgram == false) {
        getIsInMiniProgram().then(tmpBool => {
          isGetIsInMiniProgram = true;
          isInMiniProgram = tmpBool;
          axios({
            method: "post",
            url,
            data: Qs.stringify(param),
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            cancelToken: new CancelToken(c => {
              cancel = c;
            })
          })
            .then(res => {
              if (option && option.mask) {
                // Indicator.close();
              }
              resolve(res);
            })
            .catch(function (error) {
              // Indicator.close();
            });
        })
      } else {
        axios({
          method: "post",
          url,
          data: Qs.stringify(param),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          cancelToken: new CancelToken(c => {
            cancel = c;
          })
        })
          .then(res => {
            if (option && option.mask) {
              // Indicator.close();
            }
            resolve(res);
          })
          .catch(function (error) {
            // Indicator.close();
          });
      }
    });
  }
};
